import { FC, useRef } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { useFetchErrorToast } from '../../utils/useFetchErrorToasts/useFetchErrorToast';
import Header from '../../common/Header/Header';
import {
  Page,
  TableWrapper,
} from '../../common/TableWithButtonsRightLayout/TableWithButtonsRightLayout.styles';
import Table from '../../components/Table/Table';
import { useTimes } from '../../services/time/time.service';
import { readOnlyLabelTableText } from '../../constants/GlobalTexts';

const Times: FC = () => {

  const gridRef = useRef<AgGridReact>(null);
  const { data, isError: timesError } = useTimes(true);

  useFetchErrorToast([{ isError: timesError, label: 'Error fetching times', id: 'timesFetchError' }]);

  return (
    <>
      <Header breadcrumb={{ to: '/tables', label: 'All tables' }} title="Time" titleTestId={'TimePageTitle'}/>
      <Page>
        <TableWrapper>
          <Table
            rowData={data?.data}
            ref={gridRef}
            returnedRecords={data?.data?.length}
            readOnlyLabel={readOnlyLabelTableText}
            height={'100%'}
            columnDefs={[
              { field: 'timeNo', headerName: 'Time No.', flex: 0.5 },
              { field: 'statusNo', headerName: 'Status No.', flex: 0.5},
              { field: 'description', headerName: 'Description', flex: 2 },
              { field: 'fromTime', headerName: 'From Time', flex: 1 },
              { field: 'toTime', headerName: 'To Time', flex: 1 }
            ]}
            isSizeColumnsToFit={false}
          />
        </TableWrapper>
      </Page>
    </>
  );
};

export default Times;